'use strict';

module.exports = {
  template: require('./performance-review-navigation.html'),
  controller: require('./performance-review-navigation.controller'),
  controllerAs: 'vm',

  bindings: {
    titleText: '@',
    leadText: '@',
    helpTextKey: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-navigation/index.js
 ** module id = 286
 ** module chunks = 0
 **/